import React from 'react';
import './card.css';

/** A titled content block — the portal's one container shape. */
export function Card({ title, icon: Icon, action, padded = true, children }) {
  return (
    <section className="ui-card">
      {(title || action) && (
        <header className="ui-card-head">
          <h2 className="ui-card-title">
            {Icon && <Icon className="ui-card-icon" />}
            {title}
          </h2>
          {action}
        </header>
      )}
      <div className={padded ? 'ui-card-body' : undefined}>{children}</div>
    </section>
  );
}

/** Big number + label on a gradient — the dashboard's headline metric. */
export function StatCard({ icon: Icon, value, label, tone = 'primary', hint }) {
  return (
    <div className={`ui-stat ui-stat-${tone}`}>
      {Icon && <div className="ui-stat-icon"><Icon /></div>}
      <div className="ui-stat-text">
        <div className="ui-stat-value">{value}</div>
        <div className="ui-stat-label">{label}</div>
        {hint && <div className="ui-stat-hint">{hint}</div>}
      </div>
    </div>
  );
}

export function Badge({ tone = 'neutral', children }) {
  return <span className={`ui-badge ui-badge-${tone}`}>{children}</span>;
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="ui-empty">
      {Icon && <div className="ui-empty-icon"><Icon /></div>}
      <p className="ui-empty-title">{title}</p>
      {hint && <p className="ui-empty-hint">{hint}</p>}
    </div>
  );
}

export function Spinner({ label = 'جارٍ التحميل...' }) {
  return (
    <div className="ui-loading">
      <div className="ui-loading-ring" />
      <p>{label}</p>
    </div>
  );
}

/** Full-screen failure with a retry, for when the whole load fails. */
export function ErrorState({ message, onRetry }) {
  return (
    <div className="ui-error">
      <div className="ui-error-icon">!</div>
      <p className="ui-error-title">تعذّر تحميل البيانات</p>
      <p className="ui-error-msg">{message}</p>
      {onRetry && <button type="button" className="ui-btn" onClick={onRetry}>إعادة المحاولة</button>}
    </div>
  );
}
